export default {
  "Quick Base": {
    "id": "Quick Base",
    "name": "Quickbase",
    "domain": "quickbase.com",
    "color": "#74489d",
    "supported": true,
    "prefix": "qb",
    "handleAppsIndependently": true,
    "migrateTemplateToProvider": false,
    "deleteTemplateFromProvider": false,
    "refreshTokenTime": 0,
    "allowLogoutOnRender": false,
    "hasSuppliedConnections": true,
    "allowMultipleAttachments": false,
    "publishPages": true,
    "recordIdField": '3',
    "appLinkTemplate": 'https://[REALM].quickbase.com/db/[APP_ID]',
    "tableLinkTemplate": 'https://[REALM].quickbase.com/db/[TABLE_ID]?a=td',
    "fieldLinkTemplate": 'https://[REALM].quickbase.com/db/[TABLE_ID]?a=mf&fid=[FIELD_ID]',
    "recordLinkTemplate": 'https://[REALM].quickbase.com/db/[TABLE_ID]?a=dr&rid=[RID]',
    "behaviorFields": ["checkbox", "text", "float", "currency"],
    "booleanFields": ["checkbox"],
    "geoLocationFields": [{ "field": "float", "full": false }, { "field": "text", "full": true }],
    "multiSelectFields": ["multitext"],
    "sortFields": ['recordid', 'date', 'timestamp', 'text', 'float', 'currency'],
    "reportFields": ["dblink"],
    "reportControls": ["report-control"],
    "redirectFields": ["url"],
    "htmlFields": ["text", "rich-text", "text-multi-line"],
    "filenameFields": ["text"],
    "passkeyFields": ["text", "numeric", "email"],
    "ckeditorControls": ["richtext-control"],
    "connPropLabels": { "usertoken": "User Token (forms usable for public)", "apptoken": "App Token (forms not usable for public)" }
  },
  "ServiceNow": {
    "id": "ServiceNow",
    "name": "ServiceNow",
    "domain": "service-now.com",
    "color": "#1f8476",
    "supported": true,
    "prefix": "sn",
    "handleAppsIndependently": false,
    "migrateTemplateToProvider": true,
    "deleteTemplateFromProvider": true,
    "refreshTokenTime": 600000,
    "allowLogoutOnRender": true,
    "hasSuppliedConnections": false,
    "allowMultipleAttachments": true,
    "publishPages": false,
    "recordIdField": '',
    "appLinkTemplate": '',
    "tableLinkTemplate": '',
    "fieldLinkTemplate": '',
    "recordLinkTemplate": '',
    "behaviorFields": ["boolean", "string"],
    "booleanFields": ["boolean"],
    "geoLocationFields": [{ "field": "float", "full": false }, { "field": "decimal", "full": false }, { "field": "string", "full": true }],
    "multiSelectFields": ["glide_list"],
    "sortFields": [],
    "reportFields": [],
    "reportControls": [],
    "redirectFields": [],
    "htmlFields": [],
    "filenameFields": [],
    "passkeyFields": [],
    "ckeditorControls": [],
    "connPropLabels": {}
  },
  "Salesforce": {
    "id": "Salesforce",
    "name": "Salesforce",
    "domain": "salesforce.com",
    "color": "#0b9cdb",
    "supported": true,
    "prefix": "sf",
    "handleAppsIndependently": false,
    "migrateTemplateToProvider": true,
    "deleteTemplateFromProvider": false,
    "refreshTokenTime": 0,
    "allowLogoutOnRender": true,
    "hasSuppliedConnections": false,
    "allowMultipleAttachments": true,
    "publishPages": false,
    "recordIdField": '',
    "appLinkTemplate": '',
    "tableLinkTemplate": '',
    "fieldLinkTemplate": '',
    "recordLinkTemplate": '',
    "behaviorFields": ["boolean", "string"],
    "booleanFields": ["boolean"],
    "geoLocationFields": [{ "field": "double", "full": false }, { "field": "string", "full": true }],
    "multiSelectFields": ["multipicklist"],
    "sortFields": [],
    "reportFields": [],
    "reportControls": [],
    "redirectFields": [],
    "htmlFields": [],
    "filenameFields": [],
    "passkeyFields": [],
    "ckeditorControls": [],
    "connPropLabels": {}
  }
}